import { gql } from '@apollo/client';
import { chakra, HStack } from '@chakra-ui/react';
import { t } from 'i18next';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { LandscapeIcon, WarningIcon } from '~components/ui/icons';
import { ScheduleTable_ScheduleFragment } from '../__generated__/ScheduleTable.graphql';
import { UsedByCell_ScheduleFragment } from './__generated__/UsedByCell.graphql';

export function UsedByCell({
  value,
}: PropsWithChildren<CellProps<ScheduleTable_ScheduleFragment, UsedByCell_ScheduleFragment>>) {
  const syncedCount = value.syncedDisplays.length;
  const outOfSyncCount = value.outOfSyncDisplays.length;
  const syncingCount = value.syncingDisplays.length;

  return (
    <HStack spacing="4">
      <HStack spacing="2">
        <LandscapeIcon height="6" width="6" />
        <chakra.span display="block">{syncedCount}</chakra.span>
      </HStack>
      {outOfSyncCount > 0 && (
        <HStack spacing="2">
          <WarningIcon height="6" width="6" color="orange.400" />
          <chakra.span display="block">
            {outOfSyncCount} {t('outOfSync')}
          </chakra.span>
        </HStack>
      )}
      {syncingCount > 0 && (
        <HStack spacing="2">
          <WarningIcon height="6" width="6" color="orange.400" />
          <chakra.span display="block">
            {syncingCount} {t('syncing')}
          </chakra.span>
        </HStack>
      )}
    </HStack>
  );
}

UsedByCell.graphql = {
  fragments: {
    UsedByCell_schedule: gql`
      fragment UsedByCell_schedule on Schedule {
        id
        syncedDisplays: displays(filter: { state: SYNCED }) {
          id
        }
        outOfSyncDisplays: displays(filter: { state: OUT_OF_SYNC }) {
          id
        }
        syncingDisplays: displays(filter: { state: SYNCING }) {
          id
        }
      }
    `,
  },
};
